import { OfficeAssistant } from '@weave/schema-gen-ts/dist/schemas/office-assistant/v1/office_assistant_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaOfficeAssistantService = bindHTTP(OfficeAssistant);
export const serviceName = 'office-assistant';
